var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "point-info-list" }, [
    _c("li", [
      _c("span", [_vm._v("经度")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.lon) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("纬度")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.lat) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("高度")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s(_vm.datasetHeight || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("海拔")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.altitude) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("空气密度")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.rhoair) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("平均风速")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.windSpeed) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("平均气温")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.powerDensity) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("风切变")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.shearExp) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("A值")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.weibullA) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("K值")]),
      _vm._v("： "),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.weibullK) || "-"))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }